<div style="margin-left: 15%; margin-right: 15%">
    <app-notification-list></app-notification-list>
</div>
<app-members-list *ngIf="showMemberList"></app-members-list>

